import React, { Component } from "react";
import OrganisationDataTable from "../OrganisationData/OrganisationDataTable";
import CheckpointDefinitionDataTable from "../OrganisationData/CheckpointDefinitionDataTable";
import { convertCheckpointDefinition2Record } from "../OrganisationData/utils"

import Loader from '../../core/components/Loader/LinearProgress'
/* import { getDefaultHeader } from "../../utils"; */

class OrganisationData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMounted: false,
      onRowUpdate: props.updateOrganisationData,
      editable: true,
      showTable: true
    };
  }

  async componentDidMount() {
    const { getOrganisationData, getOrganisations, getCheckpointDefinitions, setDataIsObject } = this.props;
    await setDataIsObject(false);
    await getOrganisations();
    await getOrganisationData();

    var organisation = this.props.organisations.filter(o => o.IsBaseOrganisation);
    await getCheckpointDefinitions(organisation[0].ID);

    const organisationFilter = document.getElementsByClassName("MuiSelect-selectMenu")[0];
    const organisationSelect = document.getElementsByClassName("MuiSelect-selectMenu")[1];
    const organisationFilterContainer = document.getElementsByClassName("MuiInputBase-formControl")[1];
    const tableHeader = document.getElementsByClassName("MuiToolbar-gutters")[1];
    if (organisationFilter !== undefined) {
      organisationFilter.addEventListener("click", this.expandPopup.bind(this));
    }
    if (organisationSelect !== undefined) {
      organisationSelect.addEventListener("click", this.expandPopup.bind(this));
    }
    if (organisationFilterContainer !== undefined) {
      organisationFilterContainer.setAttribute("id", "org-select")
    }
    if (tableHeader !== undefined) {
      tableHeader.style.marginBottom = "35px";
    }

    this.setState({ isMounted: true, organisation: organisation[0] });
  }

  componentWillUnmount() {
    if (document.getElementsByClassName("MuiSelect-selectMenu")[0] !== undefined) {
      document.getElementsByClassName("MuiSelect-selectMenu")[0].removeEventListener("click", this.expandPopup);
    }
  }

  expandPopup = async () => {
    await new Promise(resolve => setTimeout(() => resolve(), 100));
    const { organisations } = this.props;
    const organisationPopup = document.getElementsByClassName("MuiPopover-paper")[0];
    /*const waitUntilPopupIsMounted = async () => {
      await new Promise(resolve => setTimeout(() => resolve(), 100));
      if (!organisationPopup) {
        await waitUntilPopupIsMounted();
      }
    };*/

    if (organisationPopup) {
      const orgsList = organisationPopup.childNodes[0].childNodes;
      if (orgsList) {
        const topLevel = Math.min.apply(Math, organisations.map(org => { return org.Level; }));
        let i = 0;
        orgsList.forEach(orgElement => {
          const orgObj = organisations.find(item => item.ShortName === orgElement.getAttribute("data-value"));
          const orgText = document.getElementsByClassName("MuiTypography-body1")[i];

          if (orgObj) {
            orgText.setAttribute("data-value", orgObj.ShortName);
            if (orgObj.Level === topLevel) {
              orgText.style.marginLeft = "0px";
            } else if (orgObj.Level > topLevel) {
              const margin = (Math.abs(orgObj.Level - topLevel) * 10) + 5;
              orgText.style.paddingLeft = `${margin}px`;
            }
          }

          i++;
        })
      }
      organisationPopup.setAttribute("style", organisationPopup.getAttribute("style").replace(" width: 250px;", ""));
    } /*else if (!organisationPopup) {
      await waitUntilPopupIsMounted();
    }*/
  }

  toggleTable = (open) => {
    this.setState({ showTable: open })
    this.setState({ showTable: true })
  }

  setNewRow = (id) => this.setState({ newRow: id })

  render() {
    const { organisationData, organisations, organisation, t, isFetching } = this.props;
    const { isMounted, showTable, ...rest } = this.state;

    var records = this.props.checkpointDefinitions !== undefined ? this.props.checkpointDefinitions.map(e => convertCheckpointDefinition2Record(e)) : [];

    return (
      <div
        style={{
          width: isFetching && !isMounted ? "100%" : "93%",
          margin: "0 auto",
          marginTop: isFetching && !isMounted ? 0 : 30,
          justifyContent: "center"
        }}
      >
        {
          isMounted ? (
            showTable ?
              [
                <OrganisationDataTable
                  title={t('organisation-data')}
                  data={organisationData}
                  organisations={organisations}
                  toggleTable={this.toggleTable}
                  setNewRow={this.setNewRow}
                  t={t}
                  {...rest}
                  {...this.props}
                />,
                <div style={{ height: "20px" }} />,
                <CheckpointDefinitionDataTable
                  title={t('checkpoint-definition-data')}
                  data={records}
                  organisation={organisation}
                  toggleTable={this.toggleTable}
                  setNewRow={this.setNewRow}
                  t={t}
                  {...rest}
                  {...this.props}
                  onRowAdd={this.props.createCheckpointDefinition}
                  onRowUpdate={this.props.updateCheckpointDefinition}
                />
              ]
              : null
          ) : <Loader />
        }

      </div>
    );
  }
}

export default OrganisationData;
